let state = {
  token: localStorage.getItem("ss_token") || null,
  seller: JSON.parse(localStorage.getItem("ss_seller") || "null"),
};
const listeners = new Set();

export function getAuth() { return state; }
export function subscribeAuth(fn) { listeners.add(fn); return () => listeners.delete(fn); }
function setState(next) { state = { ...state, ...next }; listeners.forEach(l => l(state)); }

export function login(token, seller) {
  localStorage.setItem("ss_token", token);
  localStorage.setItem("ss_seller", JSON.stringify(seller));
  setState({ token, seller });
}
export function updateSeller(seller) {
  localStorage.setItem("ss_seller", JSON.stringify(seller));
  setState({ seller });
}
export function logout() {
  localStorage.removeItem("ss_token");
  localStorage.removeItem("ss_seller");
  setState({ token: null, seller: null });
}
